module.exports = __webpack_public_path__ + "static/media/ST3.b1b86fc6.jpg";